import { render, staticRenderFns } from "./NotarizationGuide.vue?vue&type=template&id=36e09f73"
import script from "./NotarizationGuide.vue?vue&type=script&lang=js"
export * from "./NotarizationGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports